import { CalculatorContext } from '../machines/calculator.machine'
import { Interactions } from '../machines/tracking.machine'
import { annualConsumptionToString, paymentFrequencyToString } from './buildEmailPayload'
import { toCurrency } from './currency'

export type EventStage = 'start' | 'interacted' | 'abandon' | 'complete'
export type EventDescription = {
  contributionSlider: string
  estimatedAnnualConsumption: string
  paymentFrequency: 'weekly' | 'fortnightly' | 'monthly' | 'bimonthly' | 'quarterly' | 'annually'
  currentCost: string
}

type Payload<T> = {
  name: T
  stepName: T
  lastFieldInteractedName: string
  category: 'business'
  error: ''
} & ({ stage: 'complete'; description?: EventDescription } | { stage: 'start' | 'interacted' | 'abandon' })

type DigitalDataEvent = { event: 'page-loaded' } | { event: 'tool-navigate'; tool: Payload<'naturalpower calculator'> }

type DigitalData = DigitalDataEvent[] & {
  pushAndUpdate?: (event: DigitalDataEvent) => DigitalData
}

declare global {
  interface Window {
    digitalData: DigitalData
  }
}

const mockDigitalData: DigitalData = [
  {
    event: 'page-loaded',
  },
]

export function buildEventDescription({
  annualConsumption,
  annualConsumptionOptions,
  naturalPowerRatio,
  currentCost,
  paymentFrequency,
}: CalculatorContext): EventDescription {
  return {
    contributionSlider: `${naturalPowerRatio * 100}%`,
    estimatedAnnualConsumption: annualConsumptionToString(annualConsumption, annualConsumptionOptions)?.label as string,
    paymentFrequency: paymentFrequencyToString(paymentFrequency).toLowerCase() as EventDescription['paymentFrequency'],
    currentCost: toCurrency(currentCost),
  }
}

export function trackInteraction(
  stage: EventStage,
  lastFieldInteractedName: Interactions,
  description?: EventDescription,
) {
  const dataEvent: DigitalDataEvent = {
    event: 'tool-navigate',
    tool: {
      name: 'naturalpower calculator',
      stepName: 'naturalpower calculator',
      category: 'business',
      error: '',
      stage,
      lastFieldInteractedName,
    },
  }
  if (dataEvent.tool.stage === 'complete' && description) {
    dataEvent.tool.description = description
  }

  if (!window.digitalData) {
    const { stage, lastFieldInteractedName } = dataEvent.tool
    console?.table?.({ stage, lastFieldInteractedName })
    if ('description' in dataEvent.tool) {
      console?.table?.({ description })
    }
  }
  const digitalData = window.digitalData || mockDigitalData
  digitalData.pushAndUpdate?.(dataEvent)
  return digitalData
}
